import { render, staticRenderFns } from "./surgery-solicitation-readonly-page.vue?vue&type=template&id=cdb54f9e&scoped=true"
import script from "./surgery-solicitation-readonly-page.vue?vue&type=script&lang=ts"
export * from "./surgery-solicitation-readonly-page.vue?vue&type=script&lang=ts"
import style0 from "./surgery-solicitation-readonly-page.vue?vue&type=style&index=0&id=cdb54f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb54f9e",
  null
  
)

export default component.exports